import { environment } from 'src/environments/environment';

export class LoggerService {
	static log(msg?: any, ...optionalParams: any[]) {
		if (environment.production) return;
		console.log(msg, ...optionalParams);
	}

	static debug(msg?: any, ...optionalParams: any[]) {
		if (environment.production) return;
		console.debug(msg, ...optionalParams);
	}

	static error(msg?: any, ...optionalParams: any[]) {
		if (environment.production) return;
		console.error(msg, ...optionalParams);
	}

	static warn(msg?: any, ...optionalParams: any[]) {
		if (environment.production) return;
		console.warn(msg, ...optionalParams);
	}
}
